//$(document).ready(function(){$("#ecom-grid_h1").click(function(){$(".product-grid_row").removeClass("active"),$("#product-grid_1").addClass("active"),$(".subtitle").removeClass("active"),$(this).addClass("active")}),$("#ecom-grid_h2").click(function(){$(".product-grid_row").removeClass("active"),$("#product-grid_2").addClass("active"),$(".subtitle").removeClass("active"),$(this).addClass("active")}),$("#ecom-grid_h3").click(function(){$(".product-grid_row").removeClass("active"),$("#product-grid_3").addClass("active"),$(".subtitle").removeClass("active"),$(this).addClass("active")}),$("#ecom-grid_h4").click(function(){$(".product-grid_row").removeClass("active"),$("#product-grid_4").addClass("active"),$(".subtitle").removeClass("active"),$(this).addClass("active")}),$("#ecom-grid_h5").click(function(){$(".product-grid_row").removeClass("active"),$("#product-grid_5").addClass("active"),$(".subtitle").removeClass("active"),$(this).addClass("active")})});

$(document).ready(function() {
    $("#ecom-grid_h1").click(function() {
        $(".ecom_product-grid_row").removeClass("active"),
        $("#product-grid_1").addClass("active"),
        $(".subtitle").removeClass("active"),
        $(this).addClass("active")
    }),
    $("#ecom-grid_h2").click(function() {
        $(".ecom_product-grid_row").removeClass("active"),
        $("#product-grid_2").addClass("active"),
        $(".subtitle").removeClass("active"),
        $(this).addClass("active")
    }),
    $("#ecom-grid_h3").click(function() {
        $(".ecom_product-grid_row").removeClass("active"),
        $("#product-grid_3").addClass("active"),
        $(".subtitle").removeClass("active"),
        $(this).addClass("active")
    }),
    $("#ecom-grid_h4").click(function() {
        $(".ecom_product-grid_row").removeClass("active"),
        $("#product-grid_4").addClass("active"),
        $(".subtitle").removeClass("active"),
        $(this).addClass("active")
    }),
    $("#ecom-grid_h5").click(function() {
        $(".ecom_product-grid_row").removeClass("active"),
        $("#product-grid_5").addClass("active"),
        $(".subtitle").removeClass("active"),
        $(this).addClass("active")
    })
});
document.addEventListener("DOMContentLoaded",function(e){
  console.log("ecom slick container");
    $('.ecom_slick_container').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinity: false,
        arrows: true,
        prevArrow: '<div class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0610/9265/9449/files/Arrow---Right-Circle-1.png?v=1699264346"></div>',
        nextArrow: '<div class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/0610/9265/9449/files/Arrow---Right-Circle.png?v=1699264346"></div>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            slidesToShow: 2
          }
        }
      ]
    });
})